export default __webpack_public_path__ + "static/media/good-idea.ebc2861e.gif";